import SingleSelectField from "./SingleSelectField";

function SpeciesField() {
  return (
    <SingleSelectField
      name="species"
      label="Species"
      options={[
        { label: "Dog", value: "Dog" },
        { label: "Cat", value: "Cat" },
        { label: "Other", value: "Other" },
      ]}
      required
    />
  );
}

export default SpeciesField;
